import { FC } from 'react';
import { css } from '@emotion/react';
import { TaskCenterTypes } from '@frontend/api-task-center';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { useControlledField, RadioField } from '@frontend/design-system';
import { taskCenterTrackingIds } from '../../tracking-ids';

interface TaskSortOrderProps {
  setSortOrder: (value: TaskCenterTypes.SortField | null) => void;
  sortOrder: TaskCenterTypes.SortField | null;
}

export const TaskSortOrder: FC<TaskSortOrderProps> = ({ sortOrder, setSortOrder }) => {
  const { t } = useTranslation('task-center');

  const priorityCheckboxProps = useControlledField({
    type: 'radio',
    value: sortOrder as TaskCenterTypes.SortField,
    onChange: (value) => setSortOrder(value === '' ? null : value),
  });

  return (
    <RadioField name={''} labelPlacement='left' {...priorityCheckboxProps}>
      <RadioField.Radio
        value={TaskCenterTypes.SortField.SORT_PRIORITY}
        css={radioStyles}
        trackingId={taskCenterTrackingIds.filters.priorityDescendingFilter}
      >
        <span>
          <Icon name='priority-desc' size={16} /> {t('Priority Descending')}
        </span>
      </RadioField.Radio>
      <RadioField.Radio
        value={TaskCenterTypes.SortField.SORT_DUE_DATE}
        css={radioStyles}
        trackingId={taskCenterTrackingIds.filters.dueDateFilter}
      >
        <span>
          <Icon name='calendar-schedule-back' size={16} /> {t('Due Date')}
        </span>
      </RadioField.Radio>
    </RadioField>
  );
};

const radioStyles = css`
  padding: ${theme.spacing(0, 2)};

  span {
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};
  }
`;
